module.exports = __webpack_public_path__ + "img/DSC_2708-xs.9ea6fd64.png";